<div class="upsell-checkbox__content">
  <h2 class="upsell-checkbox__title my-4">
    Protect yourself from unexpected repair bills
  </h2>

  @if (hasFreeMonths()) {
    <div class="upsell-checkbox__promotional-banner mb-4">
      <app-icon
        [name]="'gift'"
        [size]="'md'"
        aria-hidden="true"
        class="upsell-checkbox__promotional-banner__icon"
      />
      <h5 class="upsell-checkbox__promotional-banner__title">
        {{ "CONTACT_DETAILS_UPSELL_CHECKBOX_2MF_PROMO_BANNER" | translate }}
      </h5>
    </div>
  }

  <app-benefits-list-covered-items
    [benefitsListCoveredItems]="coveredItems()"
    [title]="'Here\'s what\'s covered'"
  />

  <h3 class="upsell-checkbox__not_covered-title">What's not covered</h3>
  <ul class="upsell-checkbox__not-covered-icon-list">
    @for (item of notCoveredItems; track $index) {
      <li class="upsell-checkbox__not-covered-icon-list__item">{{ item }}</li>
    }
  </ul>

  <div class="upsell-checkbox__terms-and-conditions">
    <app-terms-and-conditions-panel [noPadding]="true" [transparent]="true" />
  </div>

  <div class="upsell-checkbox__checkbox-container">
    <app-labelled-checkbox
      (changed)="onUpsellChecked($event)"
      [border]="false"
      [checked]="customerService.customerSelectedToPurchasePlan()"
      [label]="'Add Insurance'"
      class="upsell-checkbox__checkbox"
    />

    <div class="upsell-checkbox__payment-summary mt-4">
      <div class="upsell-checkbox__payment-summary-container">
        <app-icon
          [icon]="'check'"
          [size]="'sm'"
          class="upsell-checkbox__payment-summary--icon mr-2"
        />

        @if (hasPromo()) {
          <app-single-plan-promo-price
            [titlePriceVariant]="TitlePriceVariant.Hint"
          />
        } @else {
          <p class="upsell-checkbox__title-price">
            @if (isOneOffPayment()) {
              {{
                "CONTACT_DETAILS_UPSELL_CHECKBOX_FOOTER_TITLE_PRICE_ONE_OFF"
                  | translate
                    : {
                        price:
                          selectedQuotePaymentOption().fee | currencyFormat,
                      }
              }}
            } @else {
              {{
                "CONTACT_DETAILS_UPSELL_CHECKBOX_FOOTER_TITLE_PRICE"
                  | translate
                    : {
                        price:
                          selectedQuotePaymentOption().subsequentPayment
                          | currencyFormat,
                      }
              }}
            }
          </p>
        }
      </div>
      <div class="upsell-checkbox__cancel-anytime-container">
        <app-icon
          [icon]="'check'"
          [size]="'sm'"
          class="upsell-checkbox__cancel-anytime--icon"
        />
        <p>No fixed-term contract, cancel anytime</p>
      </div>
    </div>
  </div>
  @if (applianceInGuarantee()) {
    <p class="mx-4 pb-2 upsell-checkbox__caption">
      '*From 11am on 31st March 2026 to 11am on 28th April 2026. Discount
      applies for the first 2 months of the policy only. Available on selected
      online registrations (on some sites may only be available for existing
      customers). You can’t take out another policy under the promotion for the
      same item within 12 months of buying the original policy. We have the
      right to amend, end or withdraw this promotion before the end date if
      there are circumstances outside our control.'
    </p>
  }
</div>
